import LRU from 'lru-cache'

const cache = new LRU({
  max: 20,
  maxAge: 1000 * 60 * 60
})

export const cached = async (key, fnc, query, req) => {
  const bypassCache =
    req &&
    req.headers &&
    [req.headers.pragma, req.headers['cache-control']].includes('no-cache')

  let data = {}
  if (cache.has(key) && !bypassCache) {
    console.log('from cache')
    data = cache.get(key)
  } else {
    console.log('from api')
    data = await fnc(query)
    cache.set(key, data)
  }
  return data
}
